import { useContext } from 'react';
import { modalContext } from "../contexts/modalContext.js";
export const useInModal = () => {
  const {
    inModal
  } = useContext(modalContext);
  return inModal ?? false;
};